import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    width: "42px",
    hight: "42px",
  },
  title: {
    fontSize: 20,
    color: "#231F20",
    fontWeight: "bold",
    marginLeft: 8,
  },
}));

interface IconWithTextProps {
  Icon: FC;
  title: string;
}

export const IconWithText: FC<IconWithTextProps> = ({ Icon, title }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <Icon />
      </div>
      <span className={classes.title}>{title}</span>
    </div>
  );
};
